import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { DsTextAccordionComponent } from "./ds-text-accordion.component";
import { DsTextAccordionItemModule } from "../ds-text-accordion-item/ds-text-accordion-item.module";

@NgModule({
  declarations: [DsTextAccordionComponent],
  imports: [CommonModule, DsTextAccordionItemModule],
  exports: [DsTextAccordionComponent, DsTextAccordionItemModule],
})
export class DsTextAccordionModule {}
